import analytics from '@finn-no/analytics';

export function trackSearch(props) {
    analytics.trackEvent({
        analyticsName: 'purchase-travel.search-flight.click',
        eventFlags: 'start',
        stringValue: `Traveltype: ${props.tripType}, Passenger: ${props.adults}voksne-${props.children.length}barn`,
        context: {
            fromdate: props.departureDate ? props.departureDate.format('DD.MM.YYYY') : '',
            todate: props.returnDate ? props.returnDate.format('DD.MM.YYYY') : '',
            marketcustom2: 'fly',
            marketcustom8: props.destinationCity,
            marketcustom9: props.destination,
            marketcustom10: props.origin,
            marketcustom13: props.originCity,
        },
    });
}
